<template>
    <div>
        <buttonlist
                @help="help"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <div style="display: flex;margin-top: 2px">
            <!--<el-button type="primary" size="mini" @click="partClose">获取K3模板</el-button>-->
            <el-link class="el-button--mini" type="primary" :title="$t('getapi[7588]')" href="/excel/xxx截止2021.8.25日供应商月结表_模板.xlsx" download="xxx截止2021.8.25日供应商月结表_模板.xlsx">获取K3模板</el-link>
            <el-upload
                    class="upload-demo"
                    ref="upload"
                    action=""
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :on-change="handleChange"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :http-request="uploadFile"
                    :auto-upload="true"
                    :limit="1"
                    style="margin-left: 8px;"
            >
                <el-button type="primary" size="mini">{{$t('getapi[7589]')}}
                </el-button>
            </el-upload>
            <el-button type="primary" size="mini" @click="saveToDue(0)" style="margin-left: 8px;" :disabled="!btn.savetodue">{{$t('getapi[7590]')}}</el-button>
            <el-button type="primary" size="mini" @click="saveToDue(1)" :disabled="!btn.savetodue">{{$t('getapi[7591]')}}</el-button>
            <el-button type="primary" size="mini" @click="k3InitToDue" :disabled="!btn.k3inittodue">{{$t('getapi[7592]')}}</el-button>
        </div>
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight - reduceTableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[2095]')" fixed="left"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_year" :label="$t('getapi[7593]')" fixed="left"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_month" :label="$t('getapi[3680]')" fixed="left"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1196]')" fixed="left"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_name" :label="$t('getapi[1197]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_balance" :label="$t('getapi[7594]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_status" :label="$t('getapi[1237]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="sort_id" :label="$t('getapi[2023]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="amount_closing" :label="$t('getapi[7595]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="amount_purchase" :label="$t('getapi[7596]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="amount_pay" :label="$t('getapi[6346]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="amount_due" :label="$t('getapi[7597]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="realtime_pay" :label="$t('getapi[7598]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="realtime_m00" :label="$t('getapi[7599]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="realtime_c00" :label="$t('getapi[7600]')" align="right"></el-table-column>
            <el-table-column :label="$t('getapi[7601]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.realtime_m00 + scope.row.realtime_c00}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="item_09" :label="$t('getapi[7602]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_10" :label="$t('getapi[7603]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_11" :label="$t('getapi[7604]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_12" :label="$t('getapi[7605]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_13" :label="$t('getapi[7606]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_14" :label="$t('getapi[7607]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_16" :label="$t('getapi[7608]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_17" :label="$t('getapi[7609]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_18" :label="$t('getapi[7610]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_19" :label="$t('getapi[7611]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_20" :label="$t('getapi[7612]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_21" :label="$t('getapi[7613]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_22" :label="$t('getapi[7614]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_23" :label="$t('getapi[7615]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_24" :label="$t('getapi[7616]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_25" :label="$t('getapi[7617]')" align="right"></el-table-column>
        </el-table>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="FinPaymentDueExcel_K3" ref="ser" @getser="serclick"></serce>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'3_fpdk3',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_fpdk3'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight3,
                selectData: [],
                btn: {
                    savetodue: false,
                    k3inittodue: false
                },

                uploadurl: '',
                fileList: [],
                file: null,
                scrollTop:0,
            };
        },
        beforeMount() {
            let that = this;
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6613]"),this.$t("getapi[5131]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                that.btnauthority()
            },
            btnauthority(){
                let that = this
                that.btn.savetodue = false
                that.btn.k3inittodue = false
                if(that.selectData.length == 1){
                    that.btn.savetodue = true
                    that.btn.k3inittodue = true
                }
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                that.file = file.raw
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    console.log('导入成功')
                }
                that.fileList=[];
                that.loading = false;
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
                that.loading = false;
            },
            uploadFile() {
                let that = this;
                let datetime = Common.methods.getDatetime()
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file);
                formData.append('Time1', '2021.01.01')
                formData.append('TimePay', datetime)
                formData.append('LangType', that.$processdata.getLang())                
                that.$http.urlpost('/FrmFPDK3/ImportK3', formData, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.dataSet = res.DataContent
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_fpdk3',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'FinPaymentDueExcel_K3');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/FrmFPDK3/DataList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    LangType:that.$processdata.getLang(),
                    Param: datac,
                    fromname: that.$t('getapi[6613]')
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/FrmFPDK3/DataList/ExportToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.authority()
            },
            // k3转换账期
            k3InitToDue(){
                let that = this
                this.$confirm(that.$t('getapi[8880]')+'：'+that.selectData[0].audit_year+'.'+that.selectData[0].audit_month, that.$t('getapi[194]'), {//请确认是否要将K3数据转换为初始账期?账期
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            audit_year: that.selectData[0].audit_year,
                            audit_month: that.selectData[0].audit_month,
                            OverWrite: 0
                        }
                        that.$http.urlpost('/FrmFPDK3/K3InitToDue', parm, function(res) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                            that.getView()
                        });
                    })
                    .catch(() => {
                    });
            },
            //更新账期
            saveToDue(type){
                let that = this
                let parm = {}
                if(type == 0){
                    parm = {
                        audit_year: that.selectData[0].audit_year,
                        audit_month: that.selectData[0].audit_month,
                        vender_code: '-/-'
                    }
                } else {
                    parm = {
                        audit_year: that.selectData[0].audit_year,
                        audit_month: that.selectData[0].audit_month,
                        vender_code: that.selectData[0].vender_code
                    }
                }
                that.$http.urlpost('/FrmFPDK3/K3SaveToDue', parm, function(res) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    that.getView()
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
